import produce from 'immer';

// TYPES
import { Types, AtualizarMensagem } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: AtualizarMensagem = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarMensagem {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_MENSAGEM_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_MENSAGEM_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ATUALIZAR_MENSAGEM_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_MENSAGEM_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
